import pressEntries from 'assets/press-entries.json';

import Link from 'molecules/Link';

import styles from 'components/MediaCoverage/press-releases.module.scss';

import { convertTimestamp } from 'utils/dateConverters';
import { isNonEmptyArray } from 'utils/functions';

import type { FC } from 'react';

interface ContentOptions {
  heading?: string;
  eyebrow?: string;
  description?: string;
  firstPublished?: number;
  body?: string;
}

const MediaCoverage: FC = () => {
  const sortedPressEntries = [...pressEntries].sort((a, b) => {
    const getFirstPublished = (entry: { data: any }) =>
      entry?.data?.blocks?.find((block: { component: { name: string } }) => block.component?.name === 'Content Editor')
        ?.component?.options?.firstPublished || 0;

    const aDate = new Date(getFirstPublished(a)).getTime() || 0;
    const bDate = new Date(getFirstPublished(b)).getTime() || 0;

    return bDate - aDate;
  });

  return (
    <section className={styles.results}>
      <div className={styles.resultsInner}>
        <div>
          {isNonEmptyArray(sortedPressEntries) &&
            sortedPressEntries.map(entry => {
              const retrieveContentEntry = entry?.data?.blocks?.find(
                block => block.component?.name === 'Content Editor',
              );
              const nodeId = retrieveContentEntry?.id;
              if (!nodeId) {
                return null;
              }

              const options: ContentOptions = retrieveContentEntry?.component?.options || {};
              const { heading, description, firstPublished } = options;
              const convertToPublishedDate = firstPublished ? convertTimestamp(firstPublished) : null;
              const href = entry?.data?.url || '';

              return (
                <article className={styles.hit} key={`press-release-${nodeId}`}>
                  <h2 className={styles.hitTitle}>
                    <Link href={href}>{heading && <span>{heading}</span>}</Link>
                  </h2>
                  {convertToPublishedDate && <time>{convertToPublishedDate}</time>}
                  {description && (
                    <p>
                      {description.slice(0, 200)}
                      {description.length > 200 ? '...' : ''}
                    </p>
                  )}
                </article>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default MediaCoverage;
